<template>
  <div class="pricing-page">
    <div class="cornerbadge" v-if="false">
      <span class="body-1 font-weight-black">
        Get 50% off on all the plans for a limited time using code
      </span>
      <span class="text-h5 font-aviner" style="font-weight: 900"
        >FANTASY50 !</span
      >
    </div>

    <v-col cols="12" md="12" sm="12">
      <v-img
        src="/img/fantasy_lineups_logo.png"
        class="logo mx-auto"
        width="350"
        contain
      />
    </v-col>

    <v-col cols="12" md="12" sm="12" class="mx-auto ">
      <p class="text-center ml-4 text-h6 white--text font-weight-medium">
        Clear & Simple Pricing Plan<br />
        <span class="font-weight-bold green--text"> NFL , MLB , NBA , NHL</span>
      </p>
      <p class="text-center text-body-1 grey--text text--lighten-1 mt-2">
        No confusing tiers. One subscription unlocks everything.
      </p>
    </v-col>

    <!-- Price Section for mobile -->
    <v-col cols="12" md="12" sm="12">
      <!--//? pricing toggle-->
      <v-col
        v-if="$vuetify.breakpoint.name === 'xs'"
        cols="12"
        md="12"
        sm="12"
        class="mx-auto mb-5 text-center"
      >
        <v-btn-toggle color="#73c603" v-model="toggle_exclusive">
          <v-btn>
            Weekly
          </v-btn>

          <v-btn>
            Monthly
          </v-btn>

          <v-btn>
            Yearly
          </v-btn>
        </v-btn-toggle>
      </v-col>
      <!--//? pricing toggle ends-->

      <v-col
        v-if="$vuetify.breakpoint.name === 'xs'"
        cols="12"
        md="12"
        sm="12"
        class="mt-n6 mx-auto"
      >
        <v-row class="style-1" justify="center">
          <!--//? weekly -->
          <v-col v-if="toggle_exclusive === 0" cols="12" md="3" sm="4">
            <v-card
              elevation="2"
              light
              class="mx-auto py-1 fdo-card"
              max-width="400"
            >
              <v-card-text>
                <p class="text-h5 text--primary text-center">
                  Weekly
                </p>

                <p class="text-h4 green--text font-weight-bold text-center">
                  $3.<sup>99</sup>
                </p>

                <!-- offers -->
                <v-list>
                  <v-list-item
                    v-for="(offer, index) in this.priceModelPlatinum"
                    :key="index"
                  >
                    <v-list-item-action>
                      <v-icon v-if="offer.isAvailable" color="green">
                        mdi-check-circle-outline
                      </v-icon>
                      <v-icon v-else color="red">
                        mdi-close-outline
                      </v-icon>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title
                        style="text-overflow: initial;"
                        class="subtitle-2"
                      >
                        {{ offer.title }}
                        <span class="blue--text" v-if="offer.subtitle">
                          ({{ offer.subtitle }})
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>

                <!-- offers ends... -->
              </v-card-text>
              <v-card-actions>
                <v-col class="text-center">
                  <v-btn
                    block
                    depressed
                    color="#73c604"
                    class="white--text"
                    @click.prevent="platinumModel(0)"
                  >
                    Start Subscription
                  </v-btn>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-col>

          <!--//? monthly -->
          <v-col v-if="toggle_exclusive === 1" cols="12" md="3" sm="4">
            <v-card
              elevation="2"
              light
              class="mx-auto py-1 fdo-card"
              max-width="400"
            >
              <v-card-text>
                <p class="text-h5 text--primary text-center">
                  Monthly
                </p>

                <p
                  class="text-h4 green--text text--light-4 font-weight-bold text-center"
                >
                  $9.<sup>99</sup>
                </p>

                <!-- offers -->
                <v-list>
                  <v-list-item
                    v-for="(offer, index) in this.priceModelPlatinum"
                    :key="index"
                  >
                    <v-list-item-action>
                      <v-icon v-if="offer.isAvailable" color="green">
                        mdi-check-circle-outline
                      </v-icon>
                      <v-icon v-else color="red">
                        mdi-close-outline
                      </v-icon>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title
                        style="text-overflow: initial;"
                        class="subtitle-2"
                      >
                        {{ offer.title }}
                        <span class="blue--text" v-if="offer.subtitle">
                          ({{ offer.subtitle }})
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>

                <!-- offers ends... -->
              </v-card-text>
              <v-card-actions>
                <v-col class="text-center">
                  <v-btn
                    block
                    depressed
                    class="white--text"
                    color="#73c604"
                    @click="platinumModel(1)"
                  >
                    Start Subscription
                  </v-btn>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-col>

          <!--//? yearly -->
          <v-col v-if="toggle_exclusive === 2" cols="12" md="3" sm="4">
            <v-card
              elevation="2"
              light
              class="mx-auto py-1 fdo-card"
              max-width="400"
              style="transform: translateY(-15px); border: 5px solid greenyellow;"
            >
              <v-card-text>
                <p class="text-h5 text--primary text-center">
                  <span
                    class="green--text text--lighten-1 font-weight-bolder font-aviner"
                    >Best Value</span
                  >
                  <br />
                  Yearly
                </p>

                <p class="text-h4 green--text font-weight-bold text-center">
                  $99.<sup>99</sup>
                </p>

                <!-- offers -->
                <v-list>
                  <v-list-item
                    v-for="(offer, index) in this.priceModelPlatinum"
                    :key="index"
                  >
                    <v-list-item-action>
                      <v-icon v-if="offer.isAvailable" color="green">
                        mdi-check-circle-outline
                      </v-icon>
                      <v-icon v-else color="red">
                        mdi-close-outline
                      </v-icon>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title
                        style="text-overflow: initial;"
                        class="subtitle-2"
                      >
                        {{ offer.title }}
                        <span class="blue--text" v-if="offer.subtitle">
                          ({{ offer.subtitle }})
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>

                <!-- offers ends... -->
              </v-card-text>
              <v-card-actions>
                <v-col class="text-center">
                  <v-btn
                    block
                    depressed
                    class="white--text"
                    color="#73c604"
                    @click="platinumModel(2)"
                  >
                    Start Subscription
                  </v-btn>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col
        v-if="$vuetify.breakpoint.name !== 'xs'"
        cols="12"
        md="12"
        sm="12"
        class="mt-n6 mx-auto"
      >
        <v-row class="style-1" justify="center">
          <!--//? weekly -->
          <v-col cols="12" md="3" sm="4">
            <v-card
              elevation="2"
              light
              class="mx-auto py-1 fdo-card"
              max-width="400"
            >
              <v-card-text>
                <p class="text-h5 text--primary text-center">
                  Weekly
                </p>

                <p class="text-h4 green--text font-weight-bold text-center">
                  $3.<sup>99</sup>
                </p>

                <!-- offers -->
                <v-list>
                  <v-list-item
                    v-for="(offer, index) in this.priceModelPlatinum"
                    :key="index"
                  >
                    <v-list-item-action>
                      <v-icon v-if="offer.isAvailable" color="green">
                        mdi-check-circle-outline
                      </v-icon>
                      <v-icon v-else color="red">
                        mdi-close-outline
                      </v-icon>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title
                        style="text-overflow: initial;"
                        class="subtitle-2"
                      >
                        {{ offer.title }}
                        <span class="blue--text" v-if="offer.subtitle">
                          ({{ offer.subtitle }})
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>

                <!-- offers ends... -->
              </v-card-text>
              <v-card-actions>
                <v-col class="text-center">
                  <v-btn
                    block
                    depressed
                    color="#73c604"
                    class="white--text"
                    @click.prevent="platinumModel(0)"
                  >
                    Start Subscription
                  </v-btn>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-col>

          <!--//? monthly -->
          <v-col cols="12" md="3" sm="4">
            <v-card
              elevation="2"
              light
              class="mx-auto py-1 fdo-card"
              max-width="400"
            >
              <v-card-text>
                <p class="text-h5 text--primary text-center">
                  Monthly
                </p>

                <p
                  class="text-h4 green--text text--light-4 font-weight-bold text-center"
                >
                  $9.<sup>99</sup>
                </p>

                <!-- offers -->
                <v-list>
                  <v-list-item
                    v-for="(offer, index) in this.priceModelPlatinum"
                    :key="index"
                  >
                    <v-list-item-action>
                      <v-icon v-if="offer.isAvailable" color="green">
                        mdi-check-circle-outline
                      </v-icon>
                      <v-icon v-else color="red">
                        mdi-close-outline
                      </v-icon>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title
                        style="text-overflow: initial;"
                        class="subtitle-2"
                      >
                        {{ offer.title }}
                        <span class="blue--text" v-if="offer.subtitle">
                          ({{ offer.subtitle }})
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>

                <!-- offers ends... -->
              </v-card-text>
              <v-card-actions>
                <v-col class="text-center">
                  <v-btn
                    block
                    depressed
                    class="white--text"
                    color="#73c604"
                    @click="platinumModel(1)"
                  >
                    Start Subscription
                  </v-btn>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-col>

          <!--//? yearly -->
          <v-col cols="12" md="3" sm="4">
            <v-card
              elevation="2"
              light
              class="mx-auto py-1 fdo-card"
              max-width="400"
              style="transform: translateY(-15px); border: 5px solid greenyellow;"
            >
              <v-card-text>
                <p class="text-h5 text--primary text-center">
                  <span
                    class="green--text text--lighten-1 font-weight-bolder font-aviner"
                    >Best Value</span
                  >
                  <br />
                  Yearly
                </p>

                <p class="text-h4 green--text font-weight-bold text-center">
                  $99.<sup>99</sup>
                </p>

                <!-- offers -->
                <v-list>
                  <v-list-item
                    v-for="(offer, index) in this.priceModelPlatinum"
                    :key="index"
                  >
                    <v-list-item-action>
                      <v-icon v-if="offer.isAvailable" color="green">
                        mdi-check-circle-outline
                      </v-icon>
                      <v-icon v-else color="red">
                        mdi-close-outline
                      </v-icon>
                    </v-list-item-action>

                    <v-list-item-content>
                      <v-list-item-title
                        style="text-overflow: initial;"
                        class="subtitle-2"
                      >
                        {{ offer.title }}
                        <span class="blue--text" v-if="offer.subtitle">
                          ({{ offer.subtitle }})
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>

                <!-- offers ends... -->
              </v-card-text>
              <v-card-actions>
                <v-col class="text-center">
                  <v-btn
                    block
                    depressed
                    class="white--text"
                    color="#73c604"
                    @click="platinumModel(2)"
                  >
                    Start Subscription
                  </v-btn>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col
        cols="12"
        md="12"
        sm="12"
        class="text-center mt-md-n2 mt-sm-n2 mt-n5"
      >
        <router-link
          :to="{ name: 'loginForm' }"
          class="green--text text-h6 font-weight-bold"
        >
          Already member? Login
        </router-link>
      </v-col>
    </v-col>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import UserRegister from './UserRegister.vue';

  export default {
    name: 'pricing',
    title: 'Fantasy Lineups Pricing Page',
    data() {
      return {
        toggle_exclusive: 0,
        sign_up_payload: {},
        features: [
          {
            title: 'Player Projections',
            detail: 'Live Up to the Minute Player Projections,',
            secondaryDetail: 'You can also change the projection yourself.',
          },
          {
            title: 'Fantasy Lineups DFS Optimizer',
            detail: 'NBA, MLB, NHL, NFL',
          },
          {
            title: 'Min/Max Exposure',
            detail: 'Set Minimum & Maximum Player Exposure',
          },
          { title: 'Team Stacks', detail: 'Team Exposures in an Instant' },
          {
            title: 'Expert "Top plays" filters',
            detail: 'Premium Insights Giving you an Edge',
          },
          {
            title: 'Mass Lineup Creation',
            detail: 'Build Hundreds of Lineups in Second',
          },
          { title: 'Deep Insights', detail: 'Detailed Team & Player Insights' },
          {
            title: 'Export Lineups',
            detail: 'Export Lineups into Draftkings & Fanduel',
          },
          {
            title: 'Easy to use Interface',
            detail: 'Modern Simple Straight forward',
          },
        ],
        priceModelFree: [
          {
            title: 'Access to NFL,NHL,NBA,MLB',
            isAvailable: true,
          },
          {
            title: 'Export Lineups Into CSV',
            isAvailable: true,
          },
          {
            title: 'Max Lineups per build',
            isAvailable: true,
            subtitle: '3',
          },
          {
            title: 'Number of Builds',
            isAvailable: true,
            subtitle: '1',
          },
          {
            title: 'Insights',
            isAvailable: true,
          },
          {
            title: 'Access to Our Projections',
            isAvailable: false,
          },
          {
            title: 'Team Stack',
            isAvailable: false,
          },
          {
            title: 'Min/Max Exposure',
            isAvailable: false,
          },
          {
            title: 'Import / Export Projections',
            isAvailable: false,
          },
          {
            title: 'Prop Analyzer',
            isAvailable: false,
          },
          {
            title: 'Top Plays',
            isAvailable: false,
          },
        ],
        priceModelPremium: [
          {
            title: 'Access to NFL,NHL,NBA,MLB',
            isAvailable: true,
          },
          {
            title: 'Export Lineups Into CSV',
            isAvailable: true,
          },
          {
            title: 'Max Lineups per build',
            isAvailable: true,
            subtitle: '150',
          },
          {
            title: 'Number of Builds',
            isAvailable: true,
            subtitle: 'Unlimited',
          },
          {
            title: 'Insights',
            isAvailable: true,
          },
          {
            title: 'Access to Our Projections',
            isAvailable: true,
          },
          {
            title: 'Team Stack',
            isAvailable: true,
          },
          {
            title: 'Min/Max Exposure',
            isAvailable: true,
          },
          {
            title: 'Import / Export Projections',
            isAvailable: true,
          },
          {
            title: 'Prop Analyzer',
            isAvailable: true,
          },
          {
            title: 'Top Plays',
            isAvailable: false,
          },
        ],
        priceModelPlatinum: [
          {
            title: 'Access to NFL,NHL,NBA,MLB',
            isAvailable: true,
          },
          {
            title: 'Fantasy news and analysis',
            isAvailable: true,
          },
          {
            title: 'Weekly rankings',
            isAvailable: true,
          },
          {
            title: 'Depth charts',
            isAvailable: true,
          },
          {
            title: 'Export Lineups Into CSV',
            isAvailable: true,
          },
          {
            title: 'Max Lineups per build',
            isAvailable: true,
            subtitle: '150',
          },
          {
            title: 'Number of Builds',
            isAvailable: true,
            subtitle: 'Unlimited',
          },
          {
            title: 'Insights',
            isAvailable: true,
          },
          {
            title: 'Access to Our Projections',
            isAvailable: true,
          },
          {
            title: 'Team Stack',
            isAvailable: true,
          },
          {
            title: 'Min/Max Exposure',
            isAvailable: true,
          },
          {
            title: 'Import / Export Projections',
            isAvailable: true,
          },
          {
            title: 'Prop Analyzer',
            isAvailable: true,
          },
          {
            title: 'Top Plays',
            isAvailable: true,
          },
        ],
      };
    },
    computed: {
      ...mapState('NbaModule', ['customerSession', 'portal']),
      ...mapState('userModule', ['userStatus', 'sessionWOTrialData']),
      computedHeight() {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
            return 2500;
          default:
            return 1050;
        }
      },
    },
    beforeRouteEnter(to, from, next) {
      if (localStorage.getItem('status') === 'active') {
        next({ name: 'NbaLayout' });
      } else {
        next();
      }
    },
    mounted() {
      this.GoogleAnalytic();
      this.GoogleAds();
    },
    components: {
      UserRegister,
    },
    methods: {
      GoogleAnalytic() {
        this.$gtag.config('UA-204063830-2');
        this.$gtag.pageview({ page_path: '/pricing' });
      },
      GoogleAds() {
        this.$gtag.config('AW-323506423');
      },

      freeModel() {
        const utmSource = this.$route.query.utm_source || 'unknown';
        const utmMedium = this.$route.query.utm_medium || 'unknown';
        const utmCampaign = this.$route.query.utm_campaign || 'unknown';
        const utmTerm = this.$route.query.utm_term || 'unknown';
        const utmContent = this.$route.query.utm_content || 'unknown';
        const priceID =
          this.toggle_exclusive === 0
            ? process.env.VUE_APP_FREE_WEEKLY_PRICE
            : this.toggle_exclusive === 1
            ? process.env.VUE_APP_FREE_MONTHLY_PRICE
            : process.env.VUE_APP_FREE_YEARLY_PRICE;
        if (!localStorage.getItem('stripe_customer_id')) {
          this.$router.push({
            name: 'SignUpForm',
            params: { price_id: priceID, planType: 'Free' },
            query: {
              utm_source: utmSource,
              utm_medium: utmMedium,
              utm_campaign: utmCampaign,
              utm_term: utmTerm,
              utm_content: utmContent,
            },
          });
        }
      },
      premiumModel() {
        const utmSource = this.$route.query.utm_source || 'unknown';
        const utmMedium = this.$route.query.utm_medium || 'unknown';
        const utmCampaign = this.$route.query.utm_campaign || 'unknown';
        const utmTerm = this.$route.query.utm_term || 'unknown';
        const utmContent = this.$route.query.utm_content || 'unknown';
        const priceID =
          this.toggle_exclusive === 0
            ? process.env.VUE_APP_PREMIUM_WEEKLY_PRICE
            : this.toggle_exclusive === 1
            ? process.env.VUE_APP_PREMIUM_MONTHLY_PRICE
            : process.env.VUE_APP_PREMIUM_YEARLY_PRICE;
        if (!localStorage.getItem('stripe_customer_id')) {
          this.$router.push({
            name: 'SignUpForm',
            params: { price_id: priceID },
            query: {
              utm_source: utmSource,
              utm_medium: utmMedium,
              utm_campaign: utmCampaign,
              utm_term: utmTerm,
              utm_content: utmContent,
            },
          });
        } else {
          //? check for user status...
          this.$store
            .dispatch('userModule/getUserStatus', {
              userId: localStorage.getItem('user'),
            })
            .then(() => {
              let obj = {
                stripe_customer_id: localStorage.getItem('stripe_customer_id'),
                price_id: priceID,
                type: utmSource,
              };
              if (this.userStatus.data.istrial == '1') {
                // call without trial api....
                this.$store
                  .dispatch('userModule/createSeesionWithoutTrial', obj)
                  .then(() => {
                    let path = this.sessionWOTrialData.session['url'];
                    console.log('sessionWOTrialData', path);
                    location.href = path;
                  });
              } else {
                this.$store
                  .dispatch('NbaModule/createSession', obj)
                  .then(() => {
                    //* if alreday subscrided...
                    // if (this.customerSession.length == 0) {
                    //   this.goToPortal();
                    // } else {
                    let path = this.customerSession.session['url'];
                    console.log('customerSession', path);
                    location.href = path;
                    // }
                  });
              }
            });
        }
      },
      ProceedPayment(priceId) {
        if (!localStorage.getItem('stripe_customer_id')) {
          return alert('Please Sign Up First !');
        }

        const utmSource = this.$route.query.utm_source || 'unknown';

        let obj = {
          stripe_customer_id: localStorage.getItem('stripe_customer_id'),
          price_id: priceId,
          type: utmSource,
        };
        this.$store.dispatch('NbaModule/createSession', obj).then(() => {
          location.href = this.customerSession.session['url'];
        });
      },
      platinumModel(type) {
        const utmSource = this.$route.query.utm_source || 'unknown';
        const utmMedium = this.$route.query.utm_medium || 'unknown';
        const utmCampaign = this.$route.query.utm_campaign || 'unknown';
        const utmTerm = this.$route.query.utm_term || 'unknown';
        const utmContent = this.$route.query.utm_content || 'unknown';
        const priceID =
          type === 0
            ? process.env.VUE_APP_PLATINUM_WEEKLY_PRICE
            : type === 1
            ? process.env.VUE_APP_PLATINUM_MONTHLY_PRICE
            : process.env.VUE_APP_PLATINUM_YEARLY_PRICE;

        if (!localStorage.getItem('stripe_customer_id')) {
          this.ProceedPayment(priceID);
        } else {
          //? check for user status...
          this.$store
            .dispatch('userModule/getUserStatus', {
              userId: localStorage.getItem('user'),
            })
            .then(() => {
              let obj = {
                stripe_customer_id: localStorage.getItem('stripe_customer_id'),
                price_id: priceID,
                type: utmSource,
              };
              if (this.userStatus.data.istrial == '1') {
                // call without trial api…
                this.$store
                  .dispatch('userModule/createSeesionWithoutTrial', obj)
                  .then(() => {
                    let path = this.sessionWOTrialData.session['url'];
                    console.log('sessionWOTrialData', path);
                    location.href = path;
                  });
              } else {
                this.$store
                  .dispatch('NbaModule/createSession', obj)
                  .then(() => {
                    //* if already subscribed...
                    if (this.customerSession.length == 0) {
                      this.goToPortal();
                    } else {
                      let path = this.customerSession.session['url'];
                      console.log('customerSession', path);
                      location.href = path;
                    }
                  });
              }
            });
        }
      },
      // async goToPortal() {
      //   let obj = {
      //     stripe_customer_id: localStorage.getItem('stripe_customer_id'),
      //   };
      //   await this.$store.dispatch('NbaModule/createPortal', obj);
      //   let path = this.portal.data.url;
      //   location.href = path;
      // },
    },
  };
</script>

<style lang="scss" scoped>
  .pricing-page {
    background-size: cover;
    background: rgba(0, 0, 0, 0.9) url('/img/login_form_bg.png') no-repeat
      center;
  }

  .style-1 {
    del {
      text-decoration: none;
      position: relative;

      &:before {
        content: ' ';
        display: block;
        width: 150%;
        border-top: 2px solid rgba(red, 0.8);
        height: 15px;
        position: absolute;
        bottom: 0;
        left: -10px;
        transform: rotate(-7deg);
      }
    }
  }

  .discount-text {
    position: relative;
    right: -100%;
    top: -65px;
  }

  // .cornerbadge {
  //   width: 250px;
  //   height: 250px;
  //   background: #ff0000;
  //   border-radius: 100%;
  //   border: 11px solid #fff;
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   text-align: center;
  //   color: #fff;
  //   position: absolute;
  //   z-index: 9;
  //   left: -80px;
  //   top: -80px;
  // }
  // .cornerbadge h4 {
  //   left: 20px;
  //   position: relative;
  //   line-height: normal;
  //   font-size: 24px;
  //   top: 21px;
  // }

  .cornerbadge h4 span {
    display: block;
    font-weight: normal;
  }

  // @media (max-width: 767px) {
  .cornerbadge {
    position: inherit;
    background: #72c600;
    border: none;
    width: 100%;
    height: auto;
    padding: 10px 8px;
    border-radius: 0;
    text-align: center;
    color: white;
    display: block;
    left: 0;
    top: 0;
  }

  .cornerbadge h4 {
    left: 0;
    top: 0;
    font-size: 18px;
    width: 100%;
    display: block;
  }

  .cornerbadge h4 span {
    display: initial;
    margin-left: 4px;
  }

  .cornerbadge h4 span br {
    display: none;
  }

  // }

  .fdo-card {
    transition: all 0.3s ease-in-out 0s;
    border-radius: 15px;
  }

  .fdo-card:hover {
    transform: translateY(-10px);
    box-shadow: 0px 8px 30px 0px rgba(111, 163, 6, 0.15);
  }

  .fdo-card:hover .img-container {
    transform: rotate(360deg);
  }

  .manage:hover {
    cursor: pointer;
    color: rgb(35, 233, 240);
  }
</style>
